import IndexSorter from "./indexSorter";
import Sorter from "./sorter";

export default class SortPool {
    constructor(poolParent, sorter = new IndexSorter()) {
        this.poolParent = poolParent;
        this.setSorter(sorter);

        if (this.sorter) this.update();
    }

    setSorter(sorter) {
        if (sorter instanceof Sorter) this.sorter = sorter;
        this.update();

        return this.sorter;
    }

    update() {
        [...this.poolParent.children]
            .sort((a, b) => this.sorter.sort(a, b))
            .forEach(node => this.poolParent.appendChild(node));
    }
}